export default "__VITE_ASSET__BTHpeK6T__"